const registration = {
  registration: {
    backButton: 'Volver a Iniciar sesión',
    pageHeader: 'Generación de reportes de terceros',
    installerNote:
      'Comuníquese con el administrador de su empresa/sucursal para crear una identificación de usuario e invitarlo',
    registerOption: 'Quiero registrar una nueva Empresa solar en Enphase',
    installerOption: 'Soy un instalador que trabaja para una empresa que ya instaló un sistema Enphase',
    doItYourselfOption: 'Soy un usuario que lo hago por mi cuenta y que instalo productos Enphase',
    homeownerOption: 'Soy propietario de una vivienda',
    updateSignuppage: 'Acepto que Enphase se ponga en contacto conmigo a través de llamadas y mensajes de texto al número de teléfono que introduje anteriormente para obtener información sobre el sistema, actualizaciones o mensajes de marketing relacionados con mi sistema. Estas llamadas y mensajes de texto de marketing pueden ser automarcados o generados por una voz artificial o pregrabada. Mi consentimiento a estas comunicaciones no es una condición de compra y puede ser revocado en cualquier momento y por cualquier medio razonable.',
    termsAndServices: 'He leído la %{privacyPolicy} de Enphase y he leído y comprendido los %{termsService}.',
    termsServicesSafetyDisclaimer:
      'Confirmo que he leído y acepto la %{safetyDisclaimer}, %{privacyPolicy} y las %{termsService} de Enphase.',
    safetyDisclaimer: 'Descargo de responsabilidad de seguridad',
    accountHeader: 'Detalles de su cuenta',
    companyDetails: 'Detalles de la empresa',
    firstName: 'Nombre',
    lastName: 'Apellido',
    country: 'País',
    email: 'Correo electrónico',
    verificationHeader: 'Introducir código de verificación',
    verificationNote: 'Introduzca el código de verificación de seis dígitos que se envió a %{email}',
    didntReceivedOtp: '¿No recibió el código de verificación?',
    resendOtp: 'Vuelva a enviar el código de verificación',
    setPasswordHeader: 'Establecer su contraseña de Enlighten',
    setPasswordNote: 'Debe tener entre 6 y 50 caracteres de largo y contener al menos 1 número o caracter especial',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    safetyDisclaimerNote:
      'La instalación, el servicio y el mantenimiento de los productos Enphase deben ser realizados únicamente por personal calificado. El trabajo eléctrico debe ser realizado por electricistas autorizados capacitados en el código eléctrico aplicable a la región o territorio, y conocedores de los requisitos legales y las consideraciones de seguridad asociadas con los sistemas solares, de almacenamiento y de gestión de energía. Siempre consulte los manuales y guías de instalación.',
    fieldRequired: 'Este campo es obligatorio.',
    validEmail: 'Introduce una dirección de correo electrónico válida.',
    validPhone: 'Introduce un número de teléfono válido.',
    companyName: 'Nombre de la compañía',
    streetAddress: 'Dirección postal',
    streetAddress2: 'Dirección postal 2',
    city: 'Ciudad',
    state: 'Estado',
    zip: 'Código postal/ZIP',
    supportEmail: 'Correo electrónico del Servicio de atención al cliente',
    supportPhone: 'Teléfono del Servicio de atención al cliente',
    wesbiteUrl: 'Website URL',
    companyLogo: 'Logotipo de la compañía',
    chooseFile: 'Elegir archivo',
    noFile: 'No se ha seleccionado ningún archivo',
    chooseFileNote:
      'Debe ser un archivo JPEG, GIF o PNG que no supere los 4\xa0MB. Para obtener mejores resultados, te recomendamos que utilices una imagen cuadrada con un fondo transparente de al menos 400 × 400 píxeles.',
    enphaseInstaller: 'Esta empresa instala o tiene previsto instalar sistemas Enphase',
    privacyPolicy: 'Política de privacidad',
    termsService: 'Términos y condiciones de servicio',
    andText: 'y',
    accountNote:
      'Nota: Cualquier sistema agregado a esta cuenta no será etiquetado a ningún instalador para mantenimiento.',
    phone: 'Teléfono',
    passwordMismatch: 'Las contraseñas ingresadas en los campos anteriores deben coincidir entre sí',
    updateSignupError: 'Seleccione la casilla de verificación anterior para continuar con el registro',
    privaryPolicyError:
      'Si no acepta los términos de la Política de privacidad y los Términos de servicio de Enphase, no puede registrarse en Enlighten.',
    otpSuccess: 'El código de verificación se reenvió correctamente',
    registrationSuccess: 'Su cuenta de Enlighten se ha creado con éxito',
    registrationSuccessRedirection: 'Se ha registrado correctamente en Enlighten. Iniciando su sesión...',
    login: 'Inicio de sesión',
    warningName:
      'Advertencia: Ya existe una empresa con este nombre en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    errorName:
      'Ya existe una empresa con este nombre en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    warningAddress:
      'Advertencia: Esta dirección está asociada a una empresa que ya existe en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    errorSupportEmail:
      'Este ID de correo electrónico está asociado con una empresa que ya existe en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    errorSupportPhone:
      'Este número de teléfono está asociado a una empresa que ya existe en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    warningUrl:
      'Este enlace al sitio web está asociado a una empresa que ya existe en el sistema. Para asegurarse de obtener el acceso correcto, comuníquese con el administrador de su empresa/sucursal para crear su ID de usuario o comuníquese con el Soporte de Enphase.',
    errorPhone:
      'Este número de teléfono ya está asociado a una cuenta existente. Utilice un número de contacto diferente o póngase en contacto con el Soporte de Enphase.',
    errorEmail:
      'Esta dirección de correo electrónico ya está asociada a una cuenta existente. Utilice una dirección de correo electrónico diferente o póngase en contacto con el Soporte de Enphase.',
    streetNumberEmptyError: 'No se ha encontrado el número te teléfono; verifíquelo antes de guardar.',
    recaptchaError: 'Por favor, complete la verificación reCAPTCHA para continuar.',
    infoText: 'Asegúrese de que el marcador esté colocado en la ubicación exacta.',
    warningText: 'Asegúrese de que el marcador esté colocado en la ubicación exacta.',
    locateMeText: 'Utilice la función de localización para obtener la ubicación.',
    addressCheckText: 'Asegúrese de introducir la dirección correcta',
    markerText: 'Coloque el marcador en la ubicación exacta',
    mapErrorText: '¡Lo sentimos! No hemos podido localizarlo en Google Maps.',
    validChamberNumber: '¡Entrada inválida! Se requiere un mínimo de 8 caracteres para el número de la Cámara de Comercio',
    chamberofcommerce: 'Número de la Cámara de Comercio',
  }
};

export default registration;
